/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

export const INVOICE_STATUS = 'PaymentStatus'

export const SUBMITTED = 'Submitted'
export const SUBMITTED_PENDING = 'Submitted - Pending Approval'
export const SUBMITTED_APPROVED = 'Submitted - Approved'
export const DECLINED = 'Declined'
export const REJECTED = 'Rejected'
export const PAYMENT_REJECTED = 'Payment Rejected'

export const PENDING = 'Pending'
export const APPROVED  = 'Approved'
export const SCHEDULED = 'Scheduled'
export const PAID      = 'Paid'
export const PARTIAL   = 'Partial'
export const OVERDUE_APPROVED = 'Overdue - Approved'
export const OVERDUE_PENDING = 'Overdue - Pending Approval'
export const OVERDUE = 'Overdue'

export const PARTIALLY_SCHEDULED         = 'Partially Scheduled'
export const PARTIALLY_SCHEDULED_OVERDUE = 'Partially Scheduled - Overdue'
export const SCHEDULED_OVERDUE           = 'Scheduled - Overdue'
export const PARTIALLY_PAID              = 'Partially Paid'
export const PARTIALLY_PAID_OVERDUE      = 'Partially Paid - Overdue'
export const PARTIALLY                   = 'Partially'

const NONE = 'none'

export const metaStatuses = [ PENDING, SUBMITTED, APPROVED, SCHEDULED, PAID, PARTIAL, OVERDUE_APPROVED, OVERDUE_PENDING ]

export const metaStatusFilterOptions = {
  [NONE]: {},
  [PENDING]: {
    [INVOICE_STATUS]: [ SUBMITTED_PENDING, SUBMITTED_APPROVED, SCHEDULED, SCHEDULED_OVERDUE, PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE, OVERDUE_APPROVED, OVERDUE_PENDING, DECLINED, PAYMENT_REJECTED ]
  },

  [SUBMITTED]: {
    [INVOICE_STATUS]: [ SUBMITTED_PENDING, SUBMITTED_APPROVED ]
  },

  [APPROVED]: {
    [INVOICE_STATUS]: [ SUBMITTED_APPROVED ]
  },

  [SCHEDULED]: {
    [INVOICE_STATUS]: [ SCHEDULED, SCHEDULED_OVERDUE, PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE ]
  },

  [PAID]: {
    [INVOICE_STATUS]: [ PAID, PARTIALLY_PAID, PARTIALLY_PAID_OVERDUE ]
  },

  [PARTIAL]: {
    [INVOICE_STATUS]: [ PARTIALLY_SCHEDULED, PARTIALLY_SCHEDULED_OVERDUE, PARTIALLY_PAID, PARTIALLY_PAID_OVERDUE ]
  },

  [OVERDUE]: {
    [INVOICE_STATUS]: [ OVERDUE_APPROVED, OVERDUE_PENDING, PARTIALLY_SCHEDULED_OVERDUE, SCHEDULED_OVERDUE, PARTIALLY_PAID_OVERDUE ]
  }
}

const state = []
metaStatuses.map(status => state.push({ name: status, active: false }))

function existingValues(filter, f, metaStatus) {
  const existingNotMeta = (filter[f] && filter[f].filter && filter[f].filter.split('_') || []).filter(k =>
    !~metaStatusFilterOptions[metaStatus][f].indexOf(k)
  )

  const existingMeta = []
  metaStatusFilterOptions[metaStatus][f].length === 1 && state
    .filter(status => status.active)
    .map(status => existingMeta.push(...metaStatusFilterOptions[status.name][f]))

  return [...existingNotMeta, ...existingMeta]
}

const StatusesConfig = {
  get additionalFilters() {
    let filters = []
    Object.keys(metaStatusFilterOptions).forEach(k => filters.push(...Object.keys(metaStatusFilterOptions[k])))

    return [...new Set(filters)]
  },

  filters(metaStatuses, existingFilter = {}, query) {
    let filter = {...existingFilter}

    metaStatuses.forEach(metaStatus => {
      const isActive = StatusesConfig.isActiveFilter(metaStatus, existingFilter).active

      const foundStatus = state.find(status => status.name === metaStatus) || {}

      isActive
        ? foundStatus.active = false
        : foundStatus.active = true

      Object.keys(metaStatusFilterOptions[metaStatus]).forEach(f => {
        const existing = query ? [] : existingValues(filter, f, metaStatus)

        filter[f] = {
          filter: [...new Set([
            ...existing,
            ...!isActive && metaStatusFilterOptions[metaStatus][f] || []
          ])].join('_')
        }

        filter[f] = filter[f].filter
          ? filter[f]
          : null
      })
    })

    return filter
  },

  isActiveFilter(metaStatus, existingFilter = {}, query) {
    if (query) {
      return {
        active: ~query.indexOf(metaStatus),
        partial: false
      }
    }

    let isActive = true
    let isPartiallyActive = true

    Object.keys(metaStatusFilterOptions[metaStatus]).forEach(f => {
      isActive = existingFilter[f]
        ? isActive &&
          metaStatusFilterOptions[metaStatus][f].every(s => ~existingFilter[f].filter.split('_').indexOf(s))
        : false
      isPartiallyActive = existingFilter[f]
        ? !isActive &&
          metaStatusFilterOptions[metaStatus][f].some(s => ~existingFilter[f].filter.split('_').indexOf(s)) &&
          metaStatusFilterOptions[metaStatus][f].length > 1
        : false
    })

    return { active: isActive, partial: isPartiallyActive }
  }
}

export default StatusesConfig

export const cannotCancelReasons = {
  'Cancelled'         : 'This invoice is already cancelled.',
  'NoPermission'      : 'You do not have permission to cancel invoices.',
  'NotCreatedByLogged': 'This invoice cannot be cancelled. It can only be cancelled by the client.',
  'HasPayments'       : 'This invoice cannot be cancelled. A payment has already been made against it.',
  'ProgramClosed'     : 'You cannot cancel an invoice for a Closed program, please reopen the program and try again.'
}

export const isCancelled = invoice => invoice[0] && invoice[0].data.PaymentStatus === 'Cancelled'

export const hideForCancelledOrRejected = params =>
  !params.data
    ? null
    : params.data.PaymentStatus === 'Declined' || params.data.PaymentStatus === 'Cancelled'
      ? null
      : params.data[params.colDef.field]

export const customForCancelledOrRejected = params =>
  !params.data
    ? null
    : params.data.PaymentStatus === 'Declined' || params.data.PaymentStatus === 'Cancelled' || params.data.PaymentStatus === 'Payment Rejected'
      ? params.data.PaymentStatus
      : params.data.PaymentStatus === 'Review Needed' || params.data.PaymentStatus === 'Pending Scan' || params.data.PaymentStatus < 0
        ? ''
        : params.data[params.colDef.field]



// WEBPACK FOOTER //
// ./src/components/_modules/Invoices/statuses.js